import { useAppSelector } from '../redux';
import { selectIsAuthorized, selectUserDisplayName } from '../redux/selectors';

export const useIsAuthorized = () => {
  const isAuthorized = useAppSelector(selectIsAuthorized);
  const displayName = useAppSelector(selectUserDisplayName);

  return { isAuthorized, displayName };
};
